import { UserAction } from "./api";
import { ERoutes } from "./AppRouter";
import { INavigationItem } from "./components";
import { ETLCodes } from "./locales";

export const BaseAppNavigation: INavigationItem[] = [
  {
    name: ETLCodes.ExternalRemedies,
    icon: "pivot",
    route: ERoutes.appeals,
    actions: [UserAction.ViewData],
  },
  {
    name: ETLCodes.Administration,
    icon: "cog",
    items: [
      {
        name: ETLCodes.Users,
        icon: "user",
        route: ERoutes.users,
        actions: [UserAction.EditUser],
      },
      {
        name: ETLCodes.Translations,
        icon: "text-highlight",
        route: ERoutes.translations,
        actions: [UserAction.ViewData],
      },
      {
        name: ETLCodes.MailTemplates,
        icon: "envelope",
        route: ERoutes.mailTemplates,
        actions: [UserAction.ViewData],
      },
    ],
  },
];

const InnerFindAppNavigationItemFromRoute = (
  pathname: string,
  navItem: INavigationItem
): INavigationItem | null => {
  if (navItem && navItem.route && pathname.startsWith(navItem.route)) {
    return navItem;
  }
  const nextNavItems = navItem.items;
  if (nextNavItems && nextNavItems?.length > 0) {
    for (let i of nextNavItems) {
      const found = InnerFindAppNavigationItemFromRoute(pathname, i);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const FindAppNavigationItemFromRoute = (pathname: string) => {
  for (let i of BaseAppNavigation) {
    const found = InnerFindAppNavigationItemFromRoute(pathname, i);
    if (found) return found;
  }
  return null;
};
